<script lang="ts" setup>

import { useCustomerStore } from '@entities/customer'
import { useAppBrand } from '@shared/lib/app-brand'

import LinkProfile from './LinkProfile.vue'
import LinkPaymentsSubscriptions from './LinkPaymentsSubscriptions.vue'
import LinkPricing from './LinkPricing.vue'
import BtnLogOut from './BtnLogOut.vue'
import LinkReferral from './LinkReferral.vue'

defineOptions({
  name: 'DropdownMore',
})

const store = useCustomerStore()

const { isSmartestMinds } = useAppBrand()

</script>

<template>
  <LinkProfile />
  <LinkPaymentsSubscriptions />
  <LinkReferral v-if="store.isTypePaid && !isSmartestMinds" />
  <LinkPricing
    v-if="store.isTypePaid"
    view="dropdown-item"
  />
  <BtnLogOut />
</template>
